<template>
  <transition name="slowFade">
    <h2 v-if="showTitle" ref="title" id="topTitle" class="topTitle">
      <app-icon icon="wordmark" />
      <span class="visuallyHidden">bixe</span>
      <span class="spaceName">
        {{ titleText }}
      </span>
      <span class="data"></span>
    </h2>
  </transition>
</template>

<script setup>
import { ref, computed, watch } from 'vue';
import { storeToRefs } from 'pinia';
import _ from 'underscore';
import AppIcon from '@/components/AppIcon.vue';
import spaces from '@/resources/spaces';
import { usePhaseStore } from '@/store/pinia/phase';
import { useMeetingStore } from '@/store/pinia/meeting';
import { usePageStore } from '@/store/pinia/page';
import { useReady } from '@/composables/useReady';

const phaseStore = usePhaseStore();
const meetingStore = useMeetingStore();
const pageStore = usePageStore();

const { afterCard } = useReady();
const showTitle = ref(false);

const { space } = storeToRefs(meetingStore);
const { isMeeting } = storeToRefs(pageStore);
const { currentPhase, mirroring } = storeToRefs(phaseStore);

const check = _.debounce(checkRaw, 300, true);

const titleText = computed(() => spaces[space.value]?.topTitle || '');
const showTitleRaw = computed(() => {
  return isMeeting.value && afterCard.value && !['review', 'input'].includes(currentPhase.value) && !mirroring.value.requestedBy;
});

watch(showTitleRaw, check);
function checkRaw(nv) {
  showTitle.value = nv;
}
</script>
<style lang="scss" scoped>
.wordmark-icon,
.spaceName,
.data {
  z-index: 90;
  position: absolute;
  .light-theme.beach-space & {
    color: var(--c__bg);
  }
  @media (prefers-color-scheme: light) {
    .dynamic-theme.beach-space & {
      color: var(--c__bg);
    }
  }
}

.wordmark-icon {
  top: rem(33px);
  left: rem(36px);
  width: rem(43px);
  height: rem(20px);
}

.spaceName {
  @include type-size(medium);
  line-height: (22em / 18);
  letter-spacing: rem(2.57px);
  text-transform: uppercase;
  top: rem(35px);
  left: rem(90px);
}
</style>
